import * as Sentry from "@sentry/vue";
import {currentUser} from "@/infrastructure/user";

let sentryInitialized = false;
let options = null;

/**
 * Initializes Sentry SDK in the given Vue.js application.
 *
 * @param app
 */
export function setupSentry(app) {
    if (!sentryEnabled()) {
        return;
    }

    if (sentryInitialized) {
        Sentry.addIntegration(Sentry.vueIntegration({app}));
    } else {
        Sentry.init({
            app,
            ...getOptions(),
        });
        if (currentUser.id) {
            Sentry.setUser({
                id: currentUser.id,
                email: currentUser.email,
            });
        }
        sentryInitialized = true;
    }
}

export function setupSentrySpotlight() {
    if (process.env.NODE_ENV === "development") {
        import('@spotlightjs/spotlight').then((Spotlight) =>
            Spotlight.init({injectImmediately: true})
        );
    }
}

export function captureMessage(message, severity) {
    Sentry.captureMessage(message, severity);
}

export function captureErrorMessage(message) {
    captureMessage(message, 'error');
}

export function captureException(exception) {
    Sentry.captureException(exception);
}

function getDsn() {
    return window.SENTRY_DSN;
}

function getRelease() {
    if (!window.SENTRY_RELEASE) {
        return 'master';
    }
    return window.SENTRY_RELEASE;
}

function getEnvironment() {
    if (!window.SENTRY_ENVIRONMENT) {
        return 'development';
    }
    return window.SENTRY_ENVIRONMENT;
}

function sentryEnabled() {
    if (process.env.NODE_ENV === "development") {
        return true;
    }

    const dsn = getDsn();
    return dsn !== undefined && dsn !== null && dsn !== '';
}

function getOptions() {
    if (options === null) {
        options = createOptions();
    }
    return options;
}

function createOptions() {
    return {
        dsn: getDsn(),
        release: getRelease(),
        environment: getEnvironment(),
        logErrors: true,
        replaysSessionSampleRate: 0,  // do not record regular sessions
        replaysOnErrorSampleRate: 1.0,  // record 1m of sessions with errors
        integrations: [
            Sentry.replayIntegration(),
        ],
    };
}
